(function(){
  if(window.__vfAcilKuruldu) return;
  window.__vfAcilKuruldu = true;
  function guncelle(nitelikler){
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({attributes: nitelikler})
    });
  }
  document.addEventListener("change", function(e){
    var t = e.target;
    if(!t || !t.id) return;
    if(t.id === "vf-acil-kutu"){
      e.stopPropagation();
      e.stopImmediatePropagation();
      var kap = t.closest("[data-vf-acil]");
      var ic = kap ? kap.querySelector("[data-vf-acil-ic]") : null;
      if(ic){ if(t.checked){ ic.removeAttribute("hidden"); } else { ic.setAttribute("hidden",""); } }
      if(t.checked){ guncelle({"Tarihe Yetişmeli":"Evet"}); }
      else { guncelle({"Tarihe Yetişmeli":"", "Hedef Tarih":""}); }
    }
    if(t.id === "vf-acil-tarih"){
      e.stopPropagation();
      e.stopImmediatePropagation();
      guncelle({"Tarihe Yetişmeli":"Evet", "Hedef Tarih": t.value});
    }
  }, true);
})();
